// Small fetch helper for the AI provider endpoints (BB-2764). Every call needs the
// bearer token and the tenant header; responses are returned as { ok, status, data }
// so callers can show the backend's tenant-facing error message.
export async function aiFetch(getValidToken, url, { method = "GET", body } = {}) {
  const token = await getValidToken();
  const response = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "X-Tenant-Id": localStorage.getItem("tenant"),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }
  return { ok: response.ok, status: response.status, data };
}

// First readable error message in a DRF error body.
export function errorMessage(data, fallback = "Something went wrong. Please try again.") {
  if (!data) return fallback;
  if (typeof data.error === "string") return data.error;
  if (data.errors) return Object.values(data.errors).flat().join(" ");
  const first = Object.values(data).flat().find((v) => typeof v === "string");
  return first || fallback;
}

export const PROVIDER_ICONS = {
  gemini: "✨",
  openai: "🤖",
  anthropic: "🧠",
  deepseek: "🐋",
};

export const providerIcon = (slug) => PROVIDER_ICONS[slug] || "🤖";

// Integrations page sidebar key (sidebarConstant.js "carepms.all").
export const goToIntegrations = () => {
  localStorage.setItem("activePage", "carepms.all");
  window.location.href = "/";
};
